import { Loader } from '@googlemaps/js-api-loader';

function initGoogleMap(mapElement) {
    if (null === mapElement) {
        return;
    }

    const loader = new Loader({
        apiKey: mapElement.getAttribute('data-google-map-api-key'),
        version: "weekly",
        libraries: ["maps", "marker"]
    });

    loader
        .load()
        .then((google) => {
            let mapElementContainer = mapElement.querySelector('.maier-section-map-container');
            let mapElementIframe = mapElementContainer.querySelector('.maier-section-map-container iframe');
            let mapElementContainerSiblings = mapElementContainer.querySelectorAll(':scope > *:not(.maier-section-map-container)');
            let shopElements = mapElement.querySelectorAll('.maier-section-map-shops-list-item');

            let map = new google.maps.Map(mapElementContainer, {
                mapId: "4504f8b37365c3d0",
                center: {
                    lat: parseFloat(mapElement.getAttribute('data-latitude')),
                    lng: parseFloat(mapElement.getAttribute('data-longitude'))
                },
                zoom: parseInt(mapElement.getAttribute('data-zoom'))
            });

            google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                mapElementContainer.querySelector('.maier-section-map-shops').style.display = 'flex';
            });

            let markers = JSON.parse(mapElement.getAttribute('data-markers'));
            for (let marker of markers) {
                const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                    map,
                    position: {
                        lat: parseFloat(marker.latitude),
                        lng: parseFloat(marker.longitude)
                    },
                    title: marker.title,
                });
            }

            for (let shopElement of shopElements) {
                let marker = shopElement.getAttribute('data-marker');
                if (null === marker) {
                    continue;
                }

                marker = JSON.parse(marker);
                const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                    map,
                    content: buildContent(marker),
                    position: {
                        lat: parseFloat(marker.latitude),
                        lng: parseFloat(marker.longitude)
                    },
                    title: marker.name,
                });

                AdvancedMarkerElement.addListener("gmp-click", () => {
                    showMarkerCard(AdvancedMarkerElement);
                });

                shopElement.querySelector('.maier-section-map-shops-list-item-media').addEventListener('click', function () {
                    showMarkerCard(AdvancedMarkerElement);
                });
            }

            mapElementContainer.style.height = mapElementIframe.height;
            mapElementContainer.style.width = mapElementIframe.width;
            for (let mapElementContainerSibling of mapElementContainerSiblings) {
                if (mapElementContainerSibling.localName === 'iframe') {
                    continue;
                }

                mapElementContainer.insertBefore(mapElementContainerSibling, mapElementContainer.lastElementChild)
            }
        })
    ;

    document.querySelector('.maier-section-map-shops-list-empty').innerHTML = document.querySelector('.maier-section-map-shops-list-empty').innerHTML.replace('%query%', '<span class="maier-section-map-shops-list-empty-query"></span>');

    document.querySelector('#maier-section-map-shops-search-input').addEventListener('keyup', function (e) {
        let highlightedCount = 0;
        document.querySelectorAll('.maier-section-map-shops-list-item').forEach(element => {
            element.style.display = -1 !== element.getAttribute('data-keywords').toLocaleLowerCase().indexOf(this.value.toLocaleLowerCase()) ? 'flex' : 'none';

            highlightedCount = highlightedCount + (-1 !== element.getAttribute('data-keywords').toLocaleLowerCase().indexOf(this.value.toLocaleLowerCase()) || this.value.length === 0 ? 1 : 0);
        });

        document.querySelector('.maier-section-map-shops-list-empty-query').innerHTML = this.value;
        document.querySelector('.maier-section-map-shops-list-count-number').innerHTML = highlightedCount;
        document.querySelector('.maier-section-map-shops-list-count').style.display = highlightedCount !== 0 ? 'block' : 'none';
        document.querySelector('.maier-section-map-shops-list-empty').style.display = highlightedCount === 0 ? 'block' : 'none';
    })

    document.querySelector('#maier-section-map-switch-menu-search-input').addEventListener('keyup', function (e) {
        document.querySelectorAll('.maier-section-map-shops-list-item').forEach(element => {
            element.style.display = -1 !== element.getAttribute('data-keywords').toLocaleLowerCase().indexOf(this.value.toLocaleLowerCase()) ? 'flex' : 'none';
            element.setAttribute('highlighted', -1 !== element.getAttribute('data-keywords').toLocaleLowerCase().indexOf(this.value.toLocaleLowerCase()) && this.value.length !== 0 ? 'true' : 'false');
        });
    })

    document.querySelectorAll('.maier-section-map-switch-menu-action').forEach((label) => {
        label.addEventListener('click', function () {
            document.querySelectorAll('.maier-section-map-switch-menu-action').forEach(function (label) {label.removeAttribute('checked')});
            this.setAttribute('checked', null)
        })
    })
}

function showMarkerCard(markerView) {
    document.querySelectorAll('.maier-section-map-marker-card.highlight').forEach(function (marker) {
        marker.classList.remove("highlight");
    });

    if (!markerView.content.classList.contains("highlight")) {
        markerView.content.classList.add("highlight");
        markerView.zIndex = 1;

        // NOTE: hack, not terrible to use set timeout but cannot know in advance when the gmp will be fully loaded
        setTimeout(function () {
            let map = document.querySelector('.maier-section-map-container');

            let markerPosition = markerView.getBoundingClientRect();

            if (markerPosition.y - markerView.content.offsetHeight < map.offsetTop) {
                markerView.content.style.bottom = null;
                markerView.content.style.top = '0px';
            }

            if (markerPosition.y + markerView.content.offsetHeight > map.offsetTop + map.offsetHeight) {
                markerView.content.style.bottom = '0px'
                markerView.content.style.top = null;
            }
        }, 300);
    }



    let closeButton = markerView.content.querySelector('.close');
    if (!closeButton.hasAttribute('initialized')) {
        closeButton.setAttribute('initialized', null);
        closeButton.addEventListener('click', function (e) {
            hideMarkerCard(markerView);
            e.stopPropagation();
        })
    }
}

function hideMarkerCard(markerView) {
    if (markerView.content.classList.contains("highlight")) {
        markerView.content.classList.remove("highlight");
        markerView.zIndex = null;
    }
}

function buildContent(marker) {
    const content = document.createElement("div");

    content.classList.add("maier-section-map-marker-card");
    content.innerHTML = `
        <div class="close">&times;</div>
        <div class="logo">
            <picture class="maier-section-map-shops-list-item-media">
                ${
                    marker.media.mediaBreakpoints.length > 0 ? `<source srcset="${marker.media.mediaBreakpoints[0].media.url}" media="(max-width: ${marker.media.mediaBreakpoints[0].maxWidth}px)">` : ''
                }
                <img src="${marker.media.url}">
            </picture>
        </div>
        <div class="card">
            <div class="card-banner">
                <picture class="maier-section-map-shops-list-item-media">
                    ${
                        marker.banner_media.mediaBreakpoints.length > 0 ? `<source srcset="${marker.banner_media.mediaBreakpoints[0].media.url}" media="(max-width: ${marker.banner_media.mediaBreakpoints[0].maxWidth}px)">` : ''
                    }
                    <img src="${marker.banner_media.url}">
                </picture>
            </div>
            <div class="card-information">
                <div class="card-information-name">${marker.name}</div>
                <div class="card-information-address">${marker.address}</div>
                <a href="tel:${marker.phone_number}" class="card-information-phone-number">${marker.phone_number}</a>
                <button class="maier-button maier-button-primary card-information-action-booking" data-booking-configuration="${marker.booking_button.configuration}">${marker.booking_button.label}</button>
                <a class="maier-link maier-link-primary card-information-action" href="${marker.link.href}">${marker.link.label}</a>
            </div>
        </div>
        `;

    return content;
}

function setupGoogleMap() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initGoogleMap(document.querySelector('.maier-wrapper-google-section-map'));
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGoogleMap);
} else {
    setupGoogleMap();
}